import { render, staticRenderFns } from "./FieldTextarea.vue?vue&type=template&id=1db2fc67&scoped=true"
import script from "./FieldTextarea.vue?vue&type=script&lang=ts"
export * from "./FieldTextarea.vue?vue&type=script&lang=ts"
import style0 from "./FieldTextarea.vue?vue&type=style&index=0&id=1db2fc67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2fc67",
  null
  
)

export default component.exports